export default {
  index: {
    title: '账户管理',
    tab: {
      baseTitle: '账户信息',
      resetTitle: '修改密码',
      profileTitle: '基本信息',
    },
  },
  base: {
    submitText: '保存',
    successText: '保存成功',
  },
  reset: {
    submitText: '确认提交',
    successText: '修改成功',
    verifycode: '密钥验证不通过，请重试',
    describe: '此密码会应用于汇量科技Mobvista旗下全部产品',
  },
  form: {
    name: {
      label: '用户名：',
      title: '用户名称',
    },
    contact: {
      title: '联系人',
    },
    cell: {
      title: '联系电话',
      placeholder: '请输入联系电话',
    },
    organization: {
      title: '公司',
      placeholder: '请输入公司名称',
    },
    country: {
      title: '国家',
      placeholder: '请选择国家或地区',
    },
    mail: {
      label: '邮箱：',
      placeHolder: '请输入邮箱地址',
      required: '邮箱地址不能为空',
      formatVeryfy: '邮件格式错误，请修改后重试',
      title: '联系邮箱',
    },
    password: {
      label: '当前密码',
      placeHolder: '请输入当前密码',
      required: '当前密码不能为空',
      validatePassNewOld: '新旧密码不能相同',
      validatePassSame: '您输入的密码不匹配，请重新输入',
      validatePass:
        '长度在8-20个字符之间，数字与大小写字母的组合（例如，Psw1234567）',
      validatePassEmpty: '密码不能为空',
    },
    newPassword: {
      label: '新密码',
      placeHolder: '请输入新密码',
      required: '新密码不能为空',
    },
    confirmPassword: {
      label: '确认密码',
      placeHolder: '请输入确认密码',
      required: '确认密码不能为空',
    },
    ccEmail: {
      title: '抄送邮箱地址',
      tip: '允许添加多个邮箱用于接收来自Playturbo的消息通知',
      validate: '邮箱地址错误',
      placeholder: '请输入抄送的邮箱地址',
    },
    currency: {
      title: '结算货币',
    },
  },
  plan: {
    expirationReminder: '到期提醒',
    expirationReminderTips: '您的订阅即将到期。为了持续享受服务，请及时续订。',
    insufficientQuota: '额度不足',
    insufficientQuotaTips:
      '套餐内额度耗尽，授权将在 30 天内自动取消。为了持续享受服务，请及时续订。',
    message: {
      confirm: '知道了',
    },
  },
}
